<template>
  <label
    class="v-radio"
    :for="id"
    :class="radioVariant"
  >
    <input
      :id="id"
      role="radio"
      type="radio"
      :aria-labelledby="computedName"
      :name="computedName"
      v-model="parentValue"
      :value="localValue"
      :checked="localValue === parentValue"
      :disabled="disabled"
      @click="setValue"
    >
    <span class="v-radio-label form-check-label">{{ label }}</span>
  </label>
</template>

<script>

export default {
  name: 'VRadio',
  emits: ['change'],
  data() {
    return {
      localValue: this.value,
      parentValue: null,
      radioGroup: null,
    };
  },
  props: {
    id: {
      type: String,
      required: true,
    },
    disabled: Boolean,
    label: String,
    name: String,
    color: {
      type: String,
      default: 'secondary',
    },
    value: {
      default: null,
    },
  },
  computed: {
    computedName() {
      if (this.name || !this.radioGroup) {
        return this.name
      }

      return this.radioGroup.name || `radio-${this.radioGroup.name}`
    },
    radioVariant() {
      return this.color ? `v-radio-${this.color}` : '';
    },
  },
  beforeMount() {
    this.radioGroup = this.$parent;

    this.parentValue = this.radioGroup.value;
  },
  watch: {
    localValue(value) {
      this.radioGroup.value = value;
      this.setValue();
    },
  },
  methods: {
    setValue() {
      this.radioGroup.localValue = this.value;

      this.$emit('change', this.radioGroup.localValue)
    }
  }
};
</script>
